const UNIDADE_ABREV: Record<string, string> = {
  litros: "L",
  l: "L",
  kg: "KG",
  sacos: "Sacos",
};

export function formatUnidadeMedida(descricao?: string | null, codigo?: string | null): string {
  if (descricao) {
    const key = descricao.trim().toLowerCase();
    if (UNIDADE_ABREV[key]) return UNIDADE_ABREV[key];
    if (descricao.length <= 4) return descricao.toUpperCase();
    return descricao;
  }
  return codigo ?? "";
}

export function formatInsumoLabel(
  insumoLabel?: string | null,
  unidadeMedidaDescricao?: string | null,
  unidadeCodigo?: string | null,
): string {
  const base = (insumoLabel ?? "").trim();
  const um = formatUnidadeMedida(unidadeMedidaDescricao, unidadeCodigo);
  if (!base) return um ? `(${um})` : "-";
  if (!um) return base;
  if (base.includes(`(${um})`)) return base;
  return `${base} (${um})`;
}

export function formatNumeroPtBr(value: number): string {
  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
